import { CmsValue } from 'core/type/BootstrapConfig.types';
import { HighlightCode } from 'gql/autogen/HighlightCode';

export const MAX_HIGHLIGHTS_ITEMS = 5;

interface HighlightsDisplayData {
    imageName: string;
    cmsId: number;
    isPropertyImage?: boolean;
}

export interface HighlightsItem extends HighlightsDisplayData {
    code: HighlightCode;
}

export interface StateProps {
    cms: CmsValue;
    isLoading: boolean;
    highlightsItems: HighlightsItem[];
    isMobile: boolean;
}

export interface HighlightsItemProps {
    cms: CmsValue;
    highlightsItem: HighlightsItem;
    index: number;
    isMobile: boolean;
}

export const HighlightsDisplayItem: Record<HighlightCode, HighlightsDisplayData> = {
    [HighlightCode.SAFETY]: { imageName: 'hand-safe.svg', cmsId: 351207, isPropertyImage: true },
    [HighlightCode.WORTH_THE_MONEY]: { imageName: 'medal.svg', cmsId: 351206, isPropertyImage: true },
    [HighlightCode.EASY_TO_INSTALL]: { imageName: 'like.svg', cmsId: 351205, isPropertyImage: true },
    [HighlightCode.CLEANLINESS]: { imageName: 'spray.svg', cmsId: 351204, isPropertyImage: true },
    [HighlightCode.INSTRUCTION_QUALITY]: { imageName: 'chat-check.svg', cmsId: 351203 },
    [HighlightCode.INTERNET_SPEED]: { imageName: 'wifi.svg', cmsId: 351202 },
    [HighlightCode.TRANSFER]: { imageName: 'transfer.svg', cmsId: 351201, isPropertyImage: true },
    [HighlightCode.CONVENIENT_TRAVEL]: { imageName: 'like.svg', cmsId: 351200, isPropertyImage: true },
    [HighlightCode.REDEEM]: { imageName: 'like.svg', cmsId: 351199, isPropertyImage: true },
    [HighlightCode.PICK_UP]: { imageName: 'delivery.svg', cmsId: 351198 },
    [HighlightCode.EFFICIENCY]: { imageName: 'roomservice-24.svg', cmsId: 351197 },
    [HighlightCode.SKIP_THE_LINE_CONVENIENCE]: { imageName: 'personal-space.svg', cmsId: 351196 },
    [HighlightCode.FAST_LINE]: { imageName: 'door.svg', cmsId: 351195, isPropertyImage: true },
    [HighlightCode.PUBLIC_TRANSPORTATION_ACCESS]: { imageName: 'bus.svg', cmsId: 351194, isPropertyImage: true },
    [HighlightCode.DISTANCE_FROM_CITY_CENTER]: { imageName: 'hotel.svg', cmsId: 351193, isPropertyImage: true },
    [HighlightCode.FOOD_VARIETY]: { imageName: 'forkSpoon.svg', cmsId: 351192, isPropertyImage: true },
    [HighlightCode.FOOD_QUALITY]: { imageName: 'croissant.svg', cmsId: 351191, isPropertyImage: true },
    [HighlightCode.PHOTO_OPPORTUNITY]: { imageName: 'location.svg', cmsId: 351190, isPropertyImage: true },
    [HighlightCode.MUST_SEE_LANDMARK]: { imageName: 'landmark2.svg', cmsId: 351189 },
    [HighlightCode.VIEW]: { imageName: 'forest.svg', cmsId: 351188, isPropertyImage: true },
    [HighlightCode.RELAXING]: { imageName: 'yoga1.svg', cmsId: 351187 },
    [HighlightCode.TOUR]: { imageName: 'landmark2.svg', cmsId: 351185 },
    [HighlightCode.EXPERIENCE]: { imageName: 'like.svg', cmsId: 351184, isPropertyImage: true },
    [HighlightCode.IMMERSIVE_EXPERIENCE]: { imageName: 'swimming-pool.svg', cmsId: 351183, isPropertyImage: true },
    [HighlightCode.LUXURY_EXPERIENCE]: { imageName: 'cocktail.svg', cmsId: 351182, isPropertyImage: true },
    [HighlightCode.THRILLING_EXPERIENCE]: { imageName: 'like.svg', cmsId: 351186, isPropertyImage: true },
    [HighlightCode.ROMANTIC_EXPERIENCE]: { imageName: 'heart-health.svg', cmsId: 351181 },
    [HighlightCode.EDUCATIONAL_EXPERIENCE]: { imageName: 'workcation.svg', cmsId: 351180, isPropertyImage: true },
    [HighlightCode.RELIABILITY]: { imageName: 'like.svg', cmsId: 351179, isPropertyImage: true },
    [HighlightCode.DRIVER_FRIENDLINESS]: { imageName: 'car.svg', cmsId: 351178 },
    [HighlightCode.QUICK_SERVICE]: { imageName: 'roomservice-24.svg', cmsId: 351177 },
    [HighlightCode.SERVICE]: { imageName: 'roomservice.svg', cmsId: 351176, isPropertyImage: true },
    [HighlightCode.STAFF]: { imageName: 'staff.svg', cmsId: 351175 },
    [HighlightCode.GUIDE]: { imageName: 'staff.svg', cmsId: 351174 },
    [HighlightCode.FAMILY]: { imageName: 'family-love.svg', cmsId: 351173, isPropertyImage: true },
    [HighlightCode.KID]: { imageName: 'baby.svg', cmsId: 351172, isPropertyImage: true },
    [HighlightCode.GROUP]: { imageName: 'family-love-1.svg', cmsId: 351171, isPropertyImage: true },
    [HighlightCode.COUPLE]: { imageName: 'baggage-pay.svg', cmsId: 351170, isPropertyImage: true },
    [HighlightCode.SOLO]: { imageName: 'traveler.svg', cmsId: 351169 },
    [HighlightCode.UNKNOWN]: { imageName: 'like.svg', cmsId: 351185, isPropertyImage: true },
};
